import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import { getProfile } from "../../../services/authservice";
import { saveConversation } from "../../../services/conversations";
import { updateUser, getUsers, getUser, sendMail } from "../../../services/users";
import Tabsharing from "../../../components/TabSharing/TabSharing";

export default class AddContactModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      isLoading: false,
      mainContacts: [],
      contacts: [],
      users: [],
      currentUserId: "",
      data: {
        users: [
          {
            userid: "",
            email: "",
            registerId: "",
            nonRegisterEmail: "",
            username: "",
            sharedtilldate: "",
            view: true,
            comment: false,
            edit: false,
          },
        ],
      },
    };
  }

  componentDidMount() {
    this.fetchInitialData();
  }

  toggle = () => {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  };

  // Fetch contacts and users
  fetchInitialData = async () => {
    this.setState({ isLoading: true });
    try {
      const token = await getProfile();
      const userRes = await getUser(token._id);
      const usersRes = await getUsers();

      const mainContacts = userRes.data.contacts || [];
      const groupedContacts = this.groupContacts(mainContacts);

      // Filter out self and already-added users
      const filteredUsers = usersRes.data.filter(
        (user) =>
          user._id !== token._id &&
          !mainContacts.some((c) => c.user._id === user._id)
      );

      this.setState({
        currentUserId: token._id,
        mainContacts,
        contacts: groupedContacts,
        users: filteredUsers,
        isLoading: false,
      });
    } catch (err) {
      toast.error("Failed to load data.");
      this.setState({ isLoading: false });
    }
  };

  // Group contacts alphabetically
  groupContacts = (contacts) => {
    const grouped = contacts.reduce((acc, contact) => {
      const group = contact.name?.[0]?.toUpperCase() || "#";
      if (!acc[group]) acc[group] = { group, children: [] };
      acc[group].children.push(contact);
      return acc;
    }, {});
    return Object.values(grouped).sort((a, b) => a.group.localeCompare(b.group));
  };

  handleSaveContact = async () => {
    this.setState({ isLoading: true });

    const token = await getProfile();
    const { users: selectedUsers } = this.state.data;
    const { mainContacts, users: allUsers } = this.state;

    const updatedContacts = [...mainContacts];
    let addedAnyContact = false;

    try {
      for (const user of selectedUsers) {
        if (user.registerId) {
          const selected = allUsers.find((u) => u._id === user.registerId);
          if (!selected) continue;

          await saveConversation({ sender: token._id, receiver: selected._id });

          const newContact = {
            user: selected,
            star: false,
            name: `${selected.contactName.first} ${selected.contactName.last}`,
            phone: selected.phones?.phone || "",
            about: selected.about,
            function: selected.function || "",
          };

          updatedContacts.push(newContact);
          this.props.addContact(newContact);
          addedAnyContact = true;
        } else if (user.nonRegisterEmail) {
          const email = user.nonRegisterEmail;
          const subject = "You're invited to join our Messenger contact";
          const content = `
        Hello,

        You've been invited to join our platform to collaborate and share information.

        Please register using the email: ${email}

        aivoluon.com

        Thank you!
      `;

          await sendMail({ email, subject, content });
          toast.info(`Invitation email sent to ${email}`);
        }
      }

      // Always close modal after actions
      this.setState({ modal: false });

      if (addedAnyContact) {
        const res = await updateUser(token._id, { contacts: updatedContacts });

        if (res.status === 200) {
          const grouped = this.groupContacts(updatedContacts);
          this.setState({
            mainContacts: updatedContacts,
            contacts: grouped,
            data: {
              ...this.state.data,
              users: [
                {
                  userid: "",
                  email: "",
                  registerId: "",
                  nonRegisterEmail: "",
                  username: "",
                  sharedtilldate: "",
                  view: true,
                  comment: false,
                  edit: false,
                },
              ],
            },
          });
          toast.success("Registered contacts added!");
        } else {
          toast.error("Failed to update contacts.");
        }
      }
    } catch (error) {
      console.error("Error in saving contact:", error);
      toast.error("Something went wrong while saving contact.");
    }

  };

  handleNotRegisteredUserChange = (name, value, userIndex) => {
    const data = { ...this.state.data };
    data.users[userIndex] = {
      ...data.users[userIndex],
      [name]: value,
    };
    this.setState({ data });
  };

  handleRegisteredUserChange = (name, value, userIndex) => {
    const selected = this.state.users.find((u) => u._id === value._id);
    if (!selected) return;

    const data = { ...this.state.data };
    data.users[userIndex] = {
      ...data.users[userIndex],
      [name]: value._id,
      registerId: value._id,
      username: selected.username,
      email: selected.email,
      avatar: selected.imageSrc,
    };
    this.setState({ data });
  };

  removeUser = (index) => {
    const updatedUsers = this.state.data.users.filter((_, i) => i !== index);
    this.setState((prevState) => ({
      data: { ...prevState.data, users: updatedUsers },
    }));
  };

  addUser = () => {
    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        users: [
          ...prevState.data.users,
          {
            username: "",
            email: "",
            registerId: "",
            nonRegisterEmail: "",
            sharedtilldate: "",
            view: true,
            comment: false,
            edit: false,
          },
        ],
      },
    }));
  };

  formatSelectUsers = (user) => (
    <div className="d-flex align-items-center">
      <img width={15} src={user.imageSrc} alt="user" className="me-2" />
      <span>{`${user.contactName.first} ${user.contactName.last}`}</span>
    </div>
  );

  getAvailableUsers = (excludeIndex) => {
    const { users } = this.state.data;

    const selectedIds = users
      .filter((_, i) => i !== excludeIndex)
      .map((u) => u.registerId)
      .filter(Boolean);

    return this.state.users.filter((user) => !selectedIds.includes(user._id));
  };


  render() {
    const { modal, users } = this.state;

    return (
      <>
        <div className="px-3 mb-3">
          <button
            onClick={this.toggle}
            className="btn btn-outline-secondary btn-sm w-100 d-flex align-items-center justify-content-center gap-2 py-1 shadow-sm"
          >
            <i className="ri-user-add-line fs-6"></i>
            <span className="fw-medium">Add Contact</span>
          </button>
        </div>

        <Modal isOpen={modal} centered toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Add Contact</ModalHeader>
          <ModalBody>
            <Tabsharing
              removeUser={this.removeUser}
              handleRegisteredUserChange={this.handleRegisteredUserChange}
              handleNotRegisteredUserChange={this.handleNotRegisteredUserChange}
              addUser={this.addUser}
              data={this.state.data}
              getAvailableUsers={this.getAvailableUsers}
              formatSelectUsers={this.formatSelectUsers}
            />
          </ModalBody>
          <ModalFooter>
            <Button color="link" onClick={this.toggle}>
              Close
            </Button>
            <Button color="primary" onClick={this.handleSaveContact}>
              Invite Contact
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}
